import http from 'plugins/axios';

export default {
    // 获取提现列表
    getWithdrawList(data) {
        return http.get({
            url: '/admin/blindBoxCoin/withdrawal/listByPage',
            data
        })
    },
    // 通过提现, 重新提现, 驳回
    /**
     * state 3:提现，9：驳回
     * @param data
     * @returns {*}
     */
    setPassOrReject(data) {
        return http.post({
            url: '/admin/blindBoxCoin/withdrawal/audit',
            data,
            dataType: 'form'
        })
    },
    // 获取自动过审
    getAutoPass(data) {
        return http.get({
            url: '/admin/blindBoxCoin/withdrawal/getAutoAuditSwitch',
            data
        })
    },
    setAutoPass(data) {
        return http.post({
            url: '/admin/blindBoxCoin/withdrawal/updateAutoAuditSwitch',
            data,
            dataType: 'form'
        })
    }
}